import { render, staticRenderFns } from "./EfficiencyTestFailuresModal.vue?vue&type=template&id=3c8d1dc5"
import script from "./EfficiencyTestFailuresModal.vue?vue&type=script&lang=js"
export * from "./EfficiencyTestFailuresModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports